import { isLiveSiteHost, isPeopleHost } from "@/lib/host/host-rewrite";
import { PEOPLE_ORIGIN, PRODUCT_ORIGIN } from "@/lib/marketing/origins";
import { currentHost } from "@/lib/host/request";

// Better Auth refuses sign-in from an untrusted origin and the assisted-care.com apex serves
// nothing, so marketing hosts use an absolute `PRODUCT_ORIGIN` door. Localhost and previews keep
// the path. Decided from the served host so server and browser agree.
function onMarketingHost(): boolean {
  const host = currentHost();
  return host !== undefined && (isPeopleHost(host) || isLiveSiteHost(host));
}

export function productDoor(path: string): string {
  const clean = path.startsWith("/") ? path : `/${path}`;
  return onMarketingHost() ? `${PRODUCT_ORIGIN}${clean}` : clean;
}

export function getLoginHostUrl(path = "/login"): string {
  return productDoor(path);
}

export function productHostRedirect(location: { pathname: string; searchStr: string }) {
  if (!onMarketingHost()) return undefined;
  return `${PRODUCT_ORIGIN}${location.pathname}${location.searchStr}`;
}

/** A ppl-ai.com page from the product's own pages; on localhost and previews the arm's copy at
 * /v2. */
export function peoplePageHref(page: string): string {
  const host = currentHost();
  return host === new URL(PRODUCT_ORIGIN).hostname ? `${PEOPLE_ORIGIN}/${page}` : `/v2/${page}`;
}

/** The free one-page signup on ppl-ai.com. */
export function freeSignupHref(): string {
  return peoplePageHref("signup");
}
